































import Vue from 'vue'

import { mapGetters } from 'vuex'
import { NetworkService } from '@/services/NetworkService'


export default Vue.extend({
  data () {
    return {
      email: '',
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      auth: 'auth/authenticated',
      currentDealer: 'dealers/currentDealer',
    }),

  },
  methods: {
    // 1: Email was sent | 2: Error | 3; Cancelled
    closeEmailDialog(status : number) : void {
      this.$emit('closeEmailDialog', status)
    },
    async sendEmail() : Promise<object> {
      this.loading = true
      const res = await NetworkService.get(
        process.env.VUE_APP_API_BASE_URL +
        '/api/v1/mail/accessory_link?dealer=' + this.currentDealer.id + '&email=' + this.email + '&productId=' + this.productId
      )
      this.loading = false
      this.closeEmailDialog(1)
      return res.data
    },
  },
  props: ['productId']
})

